import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_client_loader = _resolveComponent("client-loader")!
  const _component_client_posts_toolbar = _resolveComponent("client-posts-toolbar")!
  const _component_posts_order = _resolveComponent("posts-order")!
  const _component_pagination_mode = _resolveComponent("pagination-mode")!
  const _component_post = _resolveComponent("post")!
  const _component_posts_grid = _resolveComponent("posts-grid")!
  const _component_posts = _resolveComponent("posts")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_client_loader, {
      "client-id": _ctx.clientId,
      modelValue: _ctx.client,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.client) = $event))
    }, null, 8, ["client-id", "modelValue"]),
    (_ctx.client)
      ? (_openBlock(), _createBlock(_component_client_posts_toolbar, {
          key: 0,
          client: _ctx.client,
          filters: _ctx.filters,
          "onUpdate:filters": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters) = $event))
        }, null, 8, ["client", "filters"]))
      : _createCommentVNode("", true),
    _createVNode(_component_posts_order, {
      order: _ctx.filters.order,
      class: "q-my-sm q-mr-sm",
      flat: "",
      onChanged: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filters.order = $event))
    }, null, 8, ["order"]),
    _createVNode(_component_pagination_mode, {
      modelValue: _ctx.paginationMode,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.paginationMode) = $event)),
      flat: ""
    }, null, 8, ["modelValue"]),
    (_ctx.filters.socialSiteIds.length)
      ? (_openBlock(), _createBlock(_component_posts, {
          key: 1,
          filters: _ctx.filters,
          persist: _ctx.paginationMode === 'scroll',
          "infinite-scroll": _ctx.paginationMode === 'scroll',
          "new-page-top": _ctx.paginationMode === 'manual'
        }, {
          default: _withCtx(({ visiblePosts }) => [
            _createVNode(_component_posts_grid, { posts: visiblePosts }, {
              default: _withCtx((post) => [
                _createVNode(_component_post, {
                  post: post,
                  scrollable: ""
                }, null, 8, ["post"])
              ]),
              _: 2
            }, 1032, ["posts"])
          ]),
          _: 1
        }, 8, ["filters", "persist", "infinite-scroll", "new-page-top"]))
      : _createCommentVNode("", true)
  ]))
}